class IvPurchaseBar extends HTMLElement {
  connectedCallback() {
    this.root = document.getElementById('MainProduct-' + this.dataset.section);
    if (!this.root) return;
    this.jump = this.querySelector('[data-iv-purchase-jump]');
    this.onJump = () => {
      const radio = this.root.querySelector('variant-selects input:checked');
      const select = this.root.querySelector('variant-selects select');
      const target = radio || select || this.root.querySelector('.product-form__submit');
      if (target) { target.closest('variant-selects, .product__buy-zone')?.scrollIntoView({block:'center',behavior:'instant'}); target.focus({preventScroll:true}); this.update(); }
    };
    this.update = () => {
      const buy = this.root.querySelector('.product-form__submit');
      const price = this.root.querySelector('.product__price-block .price:not(.price--on-sale) .price-item--regular, .product__price-block .price--on-sale .price-item--sale');
      const priceOutput = this.querySelector('[data-iv-price]');
      if (price && priceOutput.textContent !== price.textContent.trim()) priceOutput.textContent = price.textContent.trim();
      this.hidden = !buy || buy.disabled || buy.getBoundingClientRect().bottom > 0 || window.innerWidth >= 990;
    };
    this.observer = new MutationObserver(records => { if(records.some(record => !this.contains(record.target))) this.update(); });
    this.observer.observe(this.root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    this.jump.addEventListener('click',this.onJump);
    window.addEventListener('scroll',this.update,{passive:true});
    window.addEventListener('resize',this.update);
    this.update();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.jump?.removeEventListener('click',this.onJump);
    window.removeEventListener('scroll',this.update);
    window.removeEventListener('resize',this.update);
  }
}
if(!customElements.get('iv-purchase-bar')) customElements.define('iv-purchase-bar',IvPurchaseBar);
